import { render, staticRenderFns } from "./ItemwiseReports.vue?vue&type=template&id=5876b265"
import script from "./ItemwiseReports.vue?vue&type=script&lang=js"
export * from "./ItemwiseReports.vue?vue&type=script&lang=js"
import style0 from "./ItemwiseReports.vue?vue&type=style&index=0&id=5876b265&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports